import { useEffect, useState } from 'react';
import { useI18n } from '@ywwwtseng/react-kit';
import { Typography } from '@ywwwtseng/tma-react-kit';
import type { Gift } from '@/types';

export function CountdownTimer({ gift }: { gift: Gift }) {
  const { t } = useI18n();
  const [timeLeft, setTimeLeft] = useState('');

  useEffect(() => {
    if (gift.status !== 'active') {
      setTimeLeft(t('common.ended'));
      return;
    }

    if (!gift.end_at) {
      return;
    }

    const end = new Date(gift.end_at).getTime();

    const updateTimer = () => {
      const now = Date.now();
      const diff = end - now;

      if (diff <= 0) {
        setTimeLeft(t('common.ended'));
        return;
      }

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      if (days > 1) {
        setTimeLeft(`${days}D${hours}H`);
        return;
      }

      setTimeLeft(
        [hours, minutes, seconds]
          .map((n) => String(n).padStart(2, '0'))
          .join(':')
      );
    };

    updateTimer();
    const timer = setInterval(updateTimer, 1000);

    return () => clearInterval(timer);
  }, [gift]);



  return (
    <Typography noWrap size="1" weight={600} className="text-red-500">
      {timeLeft}
    </Typography>
  );
}
